// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const survivors = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_SURVIVOR':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_SURVIVOR':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_SURVIVOR':
      return { ...state }
    case 'EDIT_SURVIVOR':
      return { ...state }
    case 'DELETE_SURVIVOR':
      return { ...state }
    default:
      return { ...state }
  }
}
export default survivors
